import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { colors, fonts } from 'bench-style-constants';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 1px;
  grid-row-gap: 1px;
  width: 100%;
  font-family: ${fonts.circular};
  font-size: 14px;
`;

export const Month = styled.button<{ active: boolean; highlight: boolean }>`
  color: ${colors.charcoal};
  padding: 12px 8px;
  border: 0;
  border-radius: 3px;
  text-align: center;
  background: transparent;
  flex: 1;
  ${({ highlight }) => highlight && `background: ${colors.sand}`};
  ${({ active }) => active && `background: ${colors.sand}`};

  &:hover {
    box-shadow: none;
  }
`;

export type CalendarYearProps = {
  year: number;
  selectedStartDate: string | null;
  selectedEndDate: string | null;
  yearMonthHover: string | null;
  onDateSelect: (selectedYearMonth: string) => void;
  onHover: (selectedYearMonth: string) => void;
  onUnhover: (selectedYearMonth: string) => void;
};

const isMonthInRange = (date, startDate, endDate) => {
  if (!startDate) {
    return false;
  }

  if (!endDate) {
    if (date === startDate) {
      return true;
    }

    return false;
  }

  return date >= startDate && date <= endDate;
};

const CalendarYear = (props: CalendarYearProps) => {
  const {
    year,
    selectedStartDate,
    selectedEndDate,
    yearMonthHover,
    onDateSelect,
    onHover,
    onUnhover,
  } = props;

  return (
    <Wrapper>
      {months.map((month, index) => {
        const yearMonth = moment({ year, month: index }).format('YYYY-MM');
        const active = isMonthInRange(yearMonth, selectedStartDate, selectedEndDate);
        const highlight =
          (!selectedStartDate && yearMonth === yearMonthHover) ||
          (!selectedEndDate && isMonthInRange(yearMonth, selectedStartDate, yearMonthHover));

        return (
          <Month
            active={active}
            highlight={!active && highlight}
            key={month}
            onClick={() => onDateSelect(yearMonth)}
            onMouseOver={() => onHover(yearMonth)}
            onMouseOut={() => onUnhover(yearMonth)}
            onFocus={() => onHover(yearMonth)}
            onBlur={() => onUnhover(yearMonth)}
            data-test-id={`month-${yearMonth}`}
          >
            {month}
          </Month>
        );
      })}
    </Wrapper>
  );
};

CalendarYear.defaultProps = {
  selectedStartDate: null,
  selectedEndDate: null,
};

export default CalendarYear;
